// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  accountService: 'https://dev-cms.avery.com/account',
  appDomain: 'https://dev-cms.avery.com',
  navDomain: 'https://dev-cms.avery.com/dev/avylib/dist/assets',
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  consumerPrivacyUrl: 'https://dev-cms.avery.com/ccpa',
  demandBase:
    'https://api.demandbase.com/api/v2/ip.json?key=bd38bd2672863d51e8e5dda8ca51dba2b99f302a',
  environment: 'develop',
  production: false,
  image: 'https://img.avery.com',
  domain: 'https://dev-cms.avery.com',
  magento: 'https://dev-cart.avery.com',
  dpo: 'https://dpotest.print.avery.com/dpp/public',
  dpoDownloadables:
    'https://dpotest.print.avery.com/dpp/public/v3/content/downloadables',
  dpoV3: 'v3',
  dpoV4: 'v4',
  dpoV5: 'v5',
  deploymentId: 'US_en_trial',
  ssoService: 'https://dev-cms.avery.com/authenticate',
};

export const config = {
  authKey: 'wwjH7clZ8E5v5BsgCqQ5zHYf9OlZ8dCB',
  env: 'prd',
  recaptchaKey: '6Ld76NsUAAAAAG0c0SDAT3M11Qgp5siUA39_Mr1e',
  recaptchaSecret: '6Ld76NsUAAAAALFx963ytrUOC1ssOXn6OgqmnCrj',
  theme: {
    cookieKey: 'avythmmde',
    modes: {
      default: {
        landingPage: environment.domain,
        toggleLabel: 'Avery',
      },
      industrial: {
        landingPage: `${environment.domain}/industrial`,
        toggleLabel: 'Avery Industrial',
        URLregex: /^\/industrial/,
      },
    },
  },
  version: '1.0.0',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
